import { render, staticRenderFns } from "./SMProductsFormStep.vue?vue&type=template&id=9d3ea5f4&scoped=true"
import script from "./SMProductsFormStep.vue?vue&type=script&lang=js"
export * from "./SMProductsFormStep.vue?vue&type=script&lang=js"
import style0 from "./SMProductsFormStep.vue?vue&type=style&index=0&id=9d3ea5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3ea5f4",
  null
  
)

export default component.exports